import { directionForLocale, isLocale } from "./runtime";
import { SUPPORTED_LOCALES, type Locale } from "./types";
import { useI18n } from "./I18nProvider";

export const LOCALE_NATIVE_NAMES: Readonly<Record<Locale, string>> = {
  en: "English",
  ar: "العربية",
  ru: "Русский",
  ro: "Română"
};

export function LanguageSelector() {
  const { locale, messages, setLocale } = useI18n();

  return (
    <label className="language-selector">
      <span className="i18n-sr-only">{messages.language.selectorLabel}</span>
      <select
        aria-label={messages.language.selectorLabel}
        value={locale}
        onChange={(event) => {
          const nextLocale = event.currentTarget.value;
          if (isLocale(nextLocale)) {
            setLocale(nextLocale);
          }
        }}
      >
        {SUPPORTED_LOCALES.map((optionLocale) => (
          <option
            key={optionLocale}
            value={optionLocale}
            lang={optionLocale}
            dir={directionForLocale(optionLocale)}
          >
            {LOCALE_NATIVE_NAMES[optionLocale]}
          </option>
        ))}
      </select>
    </label>
  );
}
